"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Standard = void 0;
/**
 * Model representing CCSS Standards standard information.
 *
 * @property {string}               id
 * @property {string}               name
 * @property {string}               description
 * @property {ChildStandard[]}      childStandards
 * @property {Cluster}              cluster - parent cluster
 *
 * @author braulio.castro
 */
var Standard = /** @class */ (function () {
    function Standard(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return Standard;
}());
exports.Standard = Standard;
